import { RemoteCommandsApi } from 'src/app/hickory-api';

export class MockRemoteCommandsApi extends RemoteCommandsApi { }
